<template>
  <div class="app-container">
    <el-button type="primary" size="small" @click="goBack">返回</el-button>
    <div style="margin: 20px">
      <el-form ref="detailForm" :model="deviceFeedbackDetail">

        <el-row style="display: flex;" :gutter="20">
          <el-col>
            <el-form-item label="提交者" label-width="80px">
              <div style="padding-left: 20px">
                <user-info :user="deviceFeedbackDetail"></user-info>
              </div>
            </el-form-item>
          </el-col>
          <el-col>
            <el-row>
              <el-form-item label-width="80px" label="提交时间" prop="createDate">
                <el-input disabled v-model="deviceFeedbackDetail.createTime"></el-input>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label-width="80px" label="联系方式" prop="contactAccount">
                <el-input disabled v-model="deviceFeedbackDetail.contactAccount"></el-input>
              </el-form-item>
            </el-row>

          </el-col>
        </el-row>

        <el-form-item label="sn" prop="content">
          <el-input type="textarea" disabled v-model="deviceFeedbackDetail.sn"></el-input>
        </el-form-item>

        <el-form-item label="反馈标题" prop="content">
          <el-input type="textarea" disabled v-model="deviceFeedbackDetail.title"></el-input>
        </el-form-item>
        <el-form-item label="反馈内容" prop="content">
          <el-input type="textarea" disabled rows="5" v-model="deviceFeedbackDetail.content"></el-input>
        </el-form-item>

        <el-form-item label="文件列表">
          <el-table :data="deviceFeedbackDetail.fileList" border>
            <el-table-column label="ID" prop="feedbackFileId" align="center"></el-table-column>
            <el-table-column label="文件">
              <template #default="scope">
                <div style="width: 100px; height: 100px;position: relative;">
                  <el-image style="width: 100px; height: 100px;" fit="scale-down" :key="scope.row.fileUrl"
                            :src="getImageUrl(scope.row)" lazy :preview-src-list="[getImageUrl(scope.row)]">
                  </el-image>
                  <i v-if="scope.row.fileType === 1" class="el-icon-video-play"
                     style="font-size: 30px;position: absolute;top: 35px;left: 35px;color: aliceblue;"
                     @click.stop="viewVideo(scope.$index, scope.row)"></i>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="上传时间" prop="createTime" align="center">
              <template #default="scope">
                {{ scope.row.createTime | formatDateTime }}
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>


      </el-form>
    </div>
    <!-- 预览 -->
    <el-dialog title="预览" :visible.sync="viewVideoDialog" width="65%" :destroy-on-close='true'>
      <!--			<video :src="videoSrc" controls style="width: 100%"></video>-->
      <tx-video-player style="height: 60vh" :video-url="videoEntity.fileUrl"></tx-video-player>
    </el-dialog>
  </div>

</template>

<script>
import {getDeviceFeedbackOne} from "@/api/feedback";
import {isVaild} from "@/utils/validate";
import {handleRes} from "@/utils/handleRes";
import TxVideoPlayer from "@/components/TXVideoPlayer/txVideoPlayer";
import {getCloudUrl} from "@/utils/urlutil";
import UserInfo from "@/components/UserInfo/UserInfo";

export default {
  name: "DeviceFeedbackDetail",
  components: {UserInfo, TxVideoPlayer},
  created() {
    let queryId = this.$route.query.feedbackId
    if (isVaild(queryId)) {
      this.feedbackId = queryId
      this.getDeviceFeedbackOne()
    }
  },
  data() {
    return {
      feedbackId: 0,
      deviceFeedbackDetail: {},
      videoEntity: {},
      viewVideoDialog: false,
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    getDeviceFeedbackOne() {
      getDeviceFeedbackOne({
        feedbackId: this.feedbackId
      }).then(res => {
        handleRes(res, () => {
          this.deviceFeedbackDetail = res.data
        })
      })
    },
    getImageUrl(entity) {
      return getCloudUrl(entity.fileType === 1 ? entity.faceUrl : entity.fileUrl)
    },
    viewVideo(index, entity) {
      this.videoEntity = entity;
      this.viewVideoDialog = true;
    },

  }
}
</script>

<style scoped>

</style>